/**
 * @fileoverview Agent definition for plot-snapshotter-v2.
 *
 * Emits the current chapter's new plot developments as a delta. The hook
 * appends the delta onto the prior chapter's cumulative plotSummary to form
 * the persisted snapshot. Also extracts major plot events for Stage 2 (weave).
 *
 * @category narrative.story.analysis
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'plot-snapshotter-v2',
  kind: 'primitive',
  name: 'Plot Snapshotter',
  description: 'Generates the current chapter\'s plot developments (delta) and major plot events. The hook appends the delta onto the prior chapter\'s cumulative plot summary.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.story.analysis',
    usedBy: [
      'use-plot-snapshot-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'next-chapter-suggester-v2',
      'story-beyond-suggester-v2',
    ],
  },
};
